import React from 'react'
import { t, Trans } from '@lingui/macro'
import { ButtonClean, ButtonDanger, Modal } from 'front-end/src/components'
import { useDeleteCpdEntryMutation } from 'front-end/src/pages/activity-history/ActivityHistory.codegen'

interface ActivityHistoryCPDRemoveConfirmModalProps {
  handleClose: () => void
  deleteId: number | null
  refetchTable: any
}

const ActivityHistoryCPDRemoveConfirmModal = ({
  deleteId,
  handleClose,
  refetchTable
}: ActivityHistoryCPDRemoveConfirmModalProps) => {
  const [deleteCpdEntry, { loading }] = useDeleteCpdEntryMutation({
    onCompleted: () => {
      refetchTable()
      handleClose()
    },
    onError: handleClose
  })
  const isOpened = !!deleteId

  const handleDelete = async () => {
    await deleteCpdEntry({
      variables: {
        id: deleteId
      }
    })
  }

  return (
    <Modal
      header={t`Are you sure you want to delete this activity?`}
      show={isOpened}
      cannotBeHidden={loading}
      controls={[
        <ButtonClean onClick={handleClose} key={1}>
          <Trans>Cancel</Trans>
        </ButtonClean>,
        <ButtonDanger isLoading={loading} onClick={handleDelete} key={2}>
          <Trans>Delete</Trans>
        </ButtonDanger>
      ]}
      onHide={handleClose}
    />
  )
}

export default ActivityHistoryCPDRemoveConfirmModal
